<template>
  <div class="BS-slide view-slide">
    <img src="../../assets/images/plotbook.png" />
    <div class="slide-text-part">
      <h3 class="plotbook-logo">Product Tools</h3>
      
     
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>An application that generate combined pdf of technical sheets. </p>
      <div class="text-center">
        <button v-on:click="select($event)">OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "CustomCatalogComponent"
};
</script>

<style scoped>
.plotbook-logo{
  letter-spacing: 0px;
  font-weight: normal;
}
.plotbook-logo span{
  font-weight: bold
}
</style>